import { CSSProperties } from '@com-delta-idp/mnx-ui-kit';
import { OfferStyles } from '../../models';

export const annualFee: CSSProperties = {
  fontColor: '#0b1f66',
  fontSize: '0.75rem',
  fontType: 'Whitney-Book'
};

export const benefit: CSSProperties = {
  fontColor: '#0b1f66',
  fontSize: '1rem',
  fontType: 'Whitney-Book'
};

export const buttonLabel: CSSProperties = {
  fontColor: '#0b1f66',
  fontSize: '0.875rem',
  fontType: 'Whitney-Semibold'
};

export const checkLabel: CSSProperties = {
  fontColor: '#0b1f66',
  fontSize: '0.9375rem',
  fontType: 'Whitney-Medium'
};

export const containerStyles: CSSProperties = {
  backgroundColor: '#ffffff',
  borderColor: '#99763F',
  width: 'default'
};

export const details: CSSProperties = {
  fontColor: '#0b1f66',
  fontSize: '0.625rem',
  fontType: 'Whitney-Book',
  fontStyle: 'italic'
};

export const heading1: CSSProperties = {
  backgroundColor: '#f7ebd3',
  fontColor: '#0b1f66',
  fontSize: '1.125rem',
  fontType: 'Whitney-Bold'
};

export const heading2: CSSProperties = {
  fontColor: '#0b1f66',
  fontSize: '1.125rem',
  fontType: 'Whitney-Bold'
};

export const image: CSSProperties = {
  position: 'left',
  width: 'small'
};

export const linksStyles: CSSProperties = {
  fontColor: '#4470C3',
  fontSize: '.6875rem',
  fontType: 'Whitney-Semibold'
};

export const offerStyles: OfferStyles = {
  annualFee,
  benefit,
  buttonLabel,
  checkLabel,
  checkSectionBackgroundColor: '#f7ebd3',
  containerStyles,
  details,
  heading1,
  heading2,
  image,
  links: linksStyles
};
